import {
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  EventRelatedStatusConfig,
  FINISHED_DESCRIPTION,
  WAITING_FOR_EXTRATIME_DESCRIPTION,
  WAITING_FOR_PENALTY_DESCRIPTION,
} from '../../configuration'

const otherStatusIncidents: SoccerIncidentId[] = [
  SoccerIncidentId.NotStarted,
  SoccerIncidentId.FinishedAwardedWin,
  SoccerIncidentId.Interrupted,
  SoccerIncidentId.Postponed,
  SoccerIncidentId.Abandoned,
  SoccerIncidentId.Cancelled,
  SoccerIncidentId.ToFinish,
]

export const eventRelatedStatusConfig: EventRelatedStatusConfig<
  SoccerEventStatusId,
  SoccerIncidentId
> = {
  [SoccerEventStatusId.NotStarted]: {
    possibleNextStatusIncidents: [
      SoccerIncidentId.FirstHalf,
      SoccerIncidentId.StartDelayed,
    ],
    otherStatusIncidents: otherStatusIncidents.filter(
      (incidentId) => incidentId !== SoccerIncidentId.NotStarted,
    ),
  },
  [SoccerEventStatusId.FirstHalf]: {
    possibleNextStatusIncidents: [SoccerIncidentId.Halftime],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.Halftime]: {
    possibleNextStatusIncidents: [SoccerIncidentId.SecondHalf],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.SecondHalf]: {
    possibleNextStatusIncidents: [
      {
        incidentId: SoccerIncidentId.FinishedRegularTime,
        description: FINISHED_DESCRIPTION,
      },
      {
        incidentId: SoccerIncidentId.WaitingForExtratime,
        description: WAITING_FOR_EXTRATIME_DESCRIPTION,
      },
      {
        incidentId: SoccerIncidentId.WaitingForPenalty,
        description: WAITING_FOR_PENALTY_DESCRIPTION,
      },
    ],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.WaitingForExtratime]: {
    possibleNextStatusIncidents: [SoccerIncidentId.ExtratimeFirstHalf],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.ExtratimeFirstHalf]: {
    possibleNextStatusIncidents: [SoccerIncidentId.ExtratimeHalftime],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.ExtratimeHalftime]: {
    possibleNextStatusIncidents: [SoccerIncidentId.ExtratimeSecondHalf],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.ExtratimeSecondHalf]: {
    possibleNextStatusIncidents: [
      {
        incidentId: SoccerIncidentId.WaitingForPenalty,
        description: WAITING_FOR_PENALTY_DESCRIPTION,
      },
      SoccerIncidentId.FinishedAfterExtratime,
    ],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.WaitingForPenalty]: {
    possibleNextStatusIncidents: [SoccerIncidentId.PenaltyShootoutStarted],
    otherStatusIncidents,
  },
  [SoccerEventStatusId.PenaltyShootout]: {
    possibleNextStatusIncidents: [SoccerIncidentId.FinishedAfterPenalties],
    otherStatusIncidents,
  },
}
